import React, { useState } from "react";
import { Link } from "react-router-dom";
import { arrow_icon, elementsIcon } from "../../assets/icons";
import { ExpertsImg1, ExpertsImg2, ExpertsImg3 } from "../../assets/images";
import { useQuery } from "@tanstack/react-query";
import { PublicService } from "../../services";

const DoctorCategory = () => {
  const { getSpecializationList } = PublicService();
  const { data } = useQuery({
    queryKey: ["doctors-category"],
    queryFn: () => getSpecializationList(),
  });
  const imageList = [ExpertsImg1, ExpertsImg2, ExpertsImg3];
  const specialization = data?.data?.specialization || [];

  return (
    <>
      <div className="trusted_experts over_write_experts spacing">
        <div className="container">
          <div className="page_title">
            <h2>Expert Guidance from Certified Women’s Health Professionals</h2>
            <p>
              Meet our trusted panel of women’s health specialists, dedicated to
              providing expert care, guidance, and support at every stage of
              your journey. Your well-being is in the hands of experienced
              doctors who understand your needs
            </p>
          </div>
          <div className="card_wrap">
            {specialization.length > 0 &&
              specialization.map((data, ind) => (
                <div className="item" key={ind}>
                  <Link to={`/doctors/${data?.slug}`}>
                    <div className="image_wrap">
                      <img
                        src={imageList[ind % imageList.length]}
                        alt={data.name}
                      />
                    </div>
                    <div className="content">
                      <div className="tag">
                        <img src={elementsIcon} alt="image" />
                        <b>{data?.name}</b>
                      </div>
                    </div>
                  </Link>
                </div>
              ))}
          </div>
          <div className="all_btns">
            <Link
              class="button"
              to="/doctors/"
              data-discover="true"
            >
              View All Doctors
              <img
                alt="explore-icon"
                src={arrow_icon}
              />
            </Link>
          </div>
        </div>
      </div>
    </>
  );
};

export default DoctorCategory;
